declare global {
  interface Window { __kitdexMarketingLoaded?: boolean; __kitdexHadTokenQuery?: boolean }
}

export function analyticsAllowed(path = window.location.pathname, search = window.location.search): boolean {
  if (window.__kitdexHadTokenQuery) return false;
  if (new URLSearchParams(search).has("token")) return false;
  return /^(?:\/|\/search\/?|\/browse\/?|\/shirt\/[^/]+\/?|\/blog(?:\/[^/]+)?\/?)$/.test(path);
}
